<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="24" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="670"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="用户">
                <el-table-column show-overflow-tooltip width="220">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.AccountName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.AccountName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="优惠券ID" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.ConfigCouponId" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.ConfigCouponId || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="优惠券名称" >
                <el-table-column show-overflow-tooltip width="220">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.Name" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Name || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="优惠券类型">
                <el-table-column show-overflow-tooltip width="220">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.CouponType" placeholder="请选择优惠券类型" style="width: 100%;">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in COUPONS_TYPE.COUPONTYPE" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CouponTypeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            
            <el-table-column label="发放时间">
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.CreateTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CreateTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="优惠方式">
                <el-table-column show-overflow-tooltip width="220">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.CouponMode" placeholder="请选择优惠方式" style="width: 100%;">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in COUPONS_TYPE.COUPONMODE" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CouponMode || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发放方式">
                <el-table-column show-overflow-tooltip width="220">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.GiveOutMode" placeholder="请选择发放方式" style="width: 100%;">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in COUPONS_TYPE.GIVEOUTMODE" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.GiveOutModeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNo"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { COUPONS_TYPE } from '@/config/const/common.js'
import {
    getAdminCouponStatisticsList,            //优惠券使用记录列表
} from "@/service/coupons";
  export default {
    data() {
        return {
            COUPONS_TYPE,
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,
                
                ListType: 1,           //1. 优惠卷使用记录, 2. 优惠卷过期记录, 3. 优惠卷发放记录
                
                AccountName: '',        //用户名称
                ConfigCouponId: '',     //优惠券ID
                Name: '',               //优惠券名称
                CouponType: '',         //优惠券类型  1. 发单, 2. 课程, 3. 通用
                CreateTime: [],         //创建时间
                CouponMode: '',         //优惠方式  1 满减, 2 折扣, 3 立减 
                GiveOutMode: '',        //发放方式  1. 系统发放， 2.手动领取，3. 活动触发 
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数

            
            tableData:[],
        }
    },
    activated(){
        this.handleSearch()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetAdminCouponStatisticsListFun()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetAdminCouponStatisticsListFun()
        },
        async GetAdminCouponStatisticsListFun(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.AccountName && delete data.AccountName
            !data.ConfigCouponId && delete data.ConfigCouponId
            !data.Name && delete data.Name
            !data.CouponType && delete data.CouponType
            !data.CouponMode && delete data.CouponMode
            !data.GiveOutMode && delete data.GiveOutMode
            if(data.CreateTime && data.CreateTime.length) {
                data.CreateStartTime = data.CreateTime[0]
                data.CreateEndTime = data.CreateTime[1]
            }
            delete data.CreateTime
            data.platform = 'pcweb'
            let res = await getAdminCouponStatisticsList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.List
            this.total = res.Data.TotalRows
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
</style>